import React from 'react';
import AppTitle from '../AppTitle';

const TermsAndConditions = ({ showTitle = true }) => {
  return (
    <div>
      {showTitle && (
        <div className='mb-10'>
          <AppTitle title={'Terms And Conditions'} from={'Home'} to='Contact' link='/' />
        </div>
      )}

      <div className='container custom-container'>
        <div className='row gy-6'>
          <div className='col-12 '>
            <div className='contact-section1_content'>
              {/* <h2 className='contact-section2__title'>OVERVIEW</h2> */}
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                Welcome to Say Cheeze Cakes. By accessing and placing an order through our website,
                you agree to the following terms and conditions. Please read them carefully before
                proceeding.
              </p>
            </div>

            <div className='contact-section1_content'>
              <h2 className='contact-section2__title'>Freshly Made Promise</h2>
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                All our cakes and desserts are freshly made to order with the finest ingredients. We
                do not use preservatives and chemical additives unless explicitly stated.
              </p>
            </div>

            <div className='contact-section1_content'>
              <h2 className='contact-section2__title'>Product Images</h2>
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                All images on the website are for representation purposes only. Actual products may
                vary slightly in color, design, and presentation, as each dessert is handcrafted.
              </p>
            </div>

            <div className='contact-section1_content'>
              <h2 className='contact-section2__title'>Ingredients & Allergens</h2>
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                We aim to mention key ingredients and common allergens wherever possible. However,
                it is the customer’s responsibility to inform us in advance of any food allergies or
                dietary restrictions. Please note that all products are made in a kitchen that
                handles nuts, dairy and wheat.
                <br /> At checkout, please mention any dietary restrictions or special instructions
                in the 'Special Instructions' box, such as 'I need an eggless cake,' 'gluten-free,',
                or 'I am allergic to nuts.'
                <br />
              </p>
            </div>

            <div className='contact-section1_content'>
              <h2 className='contact-section2__title'>Order Processing & Delivery Timelines</h2>
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                The estimated delivery or pickup date will be displayed.
                <br />
                If you wish to request an earlier delivery than the displayed date, kindly reach out
                to us via our WhatsApp number. We will do our best to accommodate your request,
                depending on availability and production schedule.
                <br />
                Urgent requests may incur additional charges.
              </p>
            </div>

            <div className='contact-section1_content'>
              <h2 className='contact-section2__title'>Ownership of Content</h2>
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                All website content, including but not limited to images, text, logos, designs, and
                branding, is the sole property of Say Cheeze Cakes. Reproduction, reuse, or
                distribution of any content without our written permission is strictly prohibited.
              </p>
            </div>

            <div className='contact-section1_content'>
              <h2 className='contact-section2__title'>Order Modifications & Cancellations</h2>
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                Once an order is confirmed, modifications are not guaranteed and will be considered
                case-by-case, based on production status.
              </p>
            </div>

            <div className='contact-section1_content'>
              <h2 className='contact-section2__title'>Contact Information</h2>
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                For any urgent requests, delivery changes, or allergy alerts, please message us
                directly via WhatsApp using the number provided on our website.
              </p>
            </div>

            {/*             
           
            <div className='contact-section1_content'>
              <h2 className='contact-section2__title'>SECTION 1 - ONLINE STORE TERMS</h2>
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                By agreeing to these Terms of Service, you represent that you are at least the age
                of majority in your state or province of residence, or that you are the age of
                majority in your state or province of residence and you have given us your consent
                to allow any of your minor dependents to use this site.
                <br />
                You may not use our products for any illegal or unauthorized purpose nor may you, in
                the use of the Service, violate any laws in your jurisdiction (including but not
                limited to copyright laws).
                <br />
                You must not transmit any worms, viruses, or any code of a destructive nature.
                <br />A breach or violation of any of the Terms will result in an immediate
                termination of your Services.
              </p>
            </div>
            <div className='contact-section1_content'>
              <h2 className='contact-section2__title'>SECTION 2 - GENERAL CONDITIONS</h2>
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                We reserve the right to refuse service to anyone for any reason at any time.
                <br />
                You understand that your content (not including credit card information), may be
                transferred unencrypted and involve (a) transmissions over various networks; and (b)
                changes to conform and adapt to technical requirements of connecting networks or
                devices. Credit card information is always encrypted during transfer over networks.
                <br />
                You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of
                the Service, use of the Service, or access to the Service or any contact on the
                website through which the service is provided, without express written permission by
                us.
                <br />
                The headings used in this agreement are included for convenience only and will not
                limit or otherwise affect these Terms.
                <br />
                <br />
                This format includes a clear, concise Overview and outlines the Online Store Terms
                and General Conditions.
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
